/**
 * KPE-865: Handles OAuth callback from Okta authentication service.
 * Processes user authentication, extracts user roles and permissions,
 * stores user data in IndexedDB, and redirects to main application.
 */

import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { AuthService } from 'src/app/auth/auth.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { UserRoles } from 'src/app/shared/enums/user-roles.enum';

@Component({
  selector: 'ava-login-callback',
  templateUrl: './login-callback.component.html',
  styleUrls: ['./login-callback.component.scss']
})
export class LoginCallbackComponent implements OnInit {

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private authService: AuthService,
    private router: Router,
    private _oktaStateService: OktaAuthStateService,
    private storageService: StorageService
  ) { 
  }

  async ngOnInit() {

    // Handle Login Redirect from OKTA Authorization
    await this.oktaAuth.handleLoginRedirect();
    
    // Once AuthState of loggedin user is set then check that user is registered or not in My Content Portal, if not, register it.
    this._oktaStateService.authState$.subscribe(
      (authData) => {
        if(authData.idToken)
        {
          const userDetails = authData.idToken?.claims;

          this.authService.checkIfUserRegistered(userDetails).subscribe(
            (data) => {
              if(!data['new_user']) {
                console.log("Welcome Back, ", userDetails.name);
              } else {
                console.log("Welcome First time user, ", userDetails.name);
              }
              
              let user_details = data['user_details'];
              this.authService.userDetails = user_details;

              let permissions = [];
              // Extract permissions from roles
              user_details.roles.forEach(role => {
                role.permissions.forEach((permission: any) => {
                  permissions.push(permission);
                });
              });

              // Extract permissions from usergroups
              user_details.usergroups.forEach(usergroup => {
                usergroup.roles.forEach(role => {
                  role.permissions.forEach((permission: any) => {
                    permissions.push(permission);
                  });
                });
              });
              this.authService.userPermissions = permissions;

              let userRoles = user_details.roles.map(role => {
                return role.name;
              });
              this.authService.userRoles = userRoles;

              // Store in IndexedDB
              this.storageService.setItem('userDetails', user_details);
              this.storageService.setItem('userPermissions', permissions);
              this.storageService.setItem('userRoles', userRoles);

              if(this.authService.hasUserRole(UserRoles.KCS_READONLY_REVIEWER) || this.authService.hasUserRole(UserRoles.CONTENT_REVIEWER)){
                this.router.navigateByUrl(`/app/icp#p-kcs`);
              }
              else{
                this.router.navigate(['/app']); // Navigate to specific route
              }
          });
        }
        // else{
        //   this.router.navigate(['/home']);
        // }
      }
    )
  }

  // On Submit
  navigateToHome() {
    this.router.navigate(['/app']);
  }
}
